export default {
    NO_DATA: "Нет данных для отображения"
};
